import images from "../images";

const home = {
  Navbar: {
    logo: {
      dark_logo: images.logos.dark_logo,
      light_logo: images.logos.light_logo,
     
    },
    menu_items: [
      {
        id:1,
        label: "Home",
        path: "/",
        offset: "70",
      },
      {
        id:2,
        label: "About Us",
        path: "/about",
        offset: "70",
      },
      {
        id:3,
        label: "Products",
        // path: "",
        subMenu : [
          {
            label : 'LIMS',
            path : '/product/lims'
          },
          {
            label : 'HMS',
            path : '/product/hms'
          }
        ],
        offset: "70",
      },
      {
        id:4,
        label: "Contact Us",
        path: "/contact",
        offset: "70",
      },
    ],
  },
  BannerSection: {
    heading: "Manage, Monitor, and control your Hospital!",
    paragraph: [
      "Hospitals And Healthcare Facilities Can Manage Their Operations More Successfully With The Use Of The Software System Vaidyo.",
    ],
    buttons: [
      {
        label: "Free Trail For 30 days",
        path: "/",
        type: "secondary",
      },
      {
        label: "demo",
        path: "/",
        type: "primary",
      },
    ],
    BannerImages:[
      {
        bannerImage: images.home.main_img,
      },
      {
        bannerImage: images.home.op_img,
      },
      {
        bannerImage: images.home.lab_img,
      },
      {
        bannerImage: images.home.pharmacy_img,
      },
      {
        bannerImage: images.home.ip_img,
      },
    ],
    bannerImage: images.home.main_img,
    bannerImage1: images.home.banner,
    bannerIcon: images.home.video,
  },
  PartnerSection: {
    Heading: {
      SectionTitle: "",
      SubHeading: "Used Daily More Than 100+ Hospitals In 4 States",
      align: "center",
    },
    partnerlogos: [
      {
        image: images.partner.BillLogo1,
        alt:"BillLogo1"
      },
      {
        image: images.partner.BillLogo2,
        alt:"BillLogo2"
      },
      {
        image: images.partner.AKS,
        alt:"AKS"
      },
      {
        image: images.partner.ASHOKA_DIAGNOSTICS,
        alt:"ASHOKA_DIAGNOSTICS"
      },
      {
        image: images.partner.DOCTOS_DIAGNOSTIC_CENTER,
        alt:"DOCTOS_DIAGNOSTIC_CENTER"
      },
      {
        image: images.partner.Haritha_Hospital,
        alt:"Haritha_Hospital"
      },
      {
        image: images.partner.Jyothi_Hospitals,
        alt:"Jyothi_Hospitals"
      },
      {
        image: images.partner.KUSUMA_HOSPITALS,
        alt:"KUSUMA_HOSPITALS"
      },
      {
        image: images.partner.LS_NURSING_HOME_DIAGNOSTICS,
        alt:"LS_NURSING_HOME_DIAGNOSTICS"
      },
      {
        image: images.partner.MARUTHI_LABORATORY,
        alt:"MARUTHI_LABORATORY"
      },
      {
        image: images.partner.QUALITY_DIAGNOSTICS,
        alt:"QUALITY_DIAGNOSTICS"
      },
      {
        image: images.partner.SAMYUKTHA_DIAGNOSTICS,
        alt:"SAMYUKTHA_DIAGNOSTICS"
      },
      {
        image: images.partner.card_logo,
        alt:"card_logo"
      },
      {
        image: images.partner.jagannadh_Hospitals,
        alt:"jagannadh_Hospitals"
      },
      {
        image: images.partner.kosuru_Hospital,
        alt:"kosuru_Hospital"
      },
      {
        image: images.partner.matrix_Hospital,
        alt:"matrix_Hospital"
      },
      {
        image: images.partner.SJ_HEALTH_CARE_AND_DIAGNOSTICS,
        alt:"SJ_HEALTH_CARE_AND_DIAGNOSTICS"
      },
      {
        image: images.partner.SONAKSHI_CLINICALLAB,
        alt:"SONAKSHI_CLINICALLAB"
      },
      {
        image: images.partner.SR_HOSPITALS,
        alt:"SR_HOSPITALS"
      },
      {
        image: images.partner.SRI_CLINICAL_LABORATORY,
        alt:"SRI_CLINICAL_LABORATORY"
      },
      {
        image: images.partner.SRI_HAMSINI_LAB,
        alt:"SRI_HAMSINI_LAB"
      },
      {
        image: images.partner.SRI_KARTHIKEYA_DIAGNOSTIC_CENTER,
        alt:"SRI_KARTHIKEYA_DIAGNOSTIC_CENTER"
      },
      {
        image: images.partner.SRI_NOOKAMBIKA_MEDICAL_CENTER,
        alt:"SRI_NOOKAMBIKA_MEDICAL_CENTER"
      },
      {
        image: images.partner.SRI_SAI_DIAGNOSTICS,
        alt:"SRI_SAI_DIAGNOSTICS"
      },
      {
        image: images.partner.SRI_SAI_RAM_MEDICAL_DIAGNOSTICS,
        alt:"SRI_SAI_RAM_MEDICAL_DIAGNOSTICS"
      },
      {
        image: images.partner.SRI_VENKATA_RAMANA_DIGITAL_XRAY_AND_DIAGNOSTIC_CENTER,
        alt:"SRI_VENKATA_RAMANA_DIGITAL_XRAY_AND_DIAGNOSTIC_CENTER"
      },
      {
        image: images.partner.Sri_care_Hospital,
        alt:"Sri_care_Hospital"
      },
      {
        image: images.partner.Sujatha_Hospital_Logo,
        alt:"Sujatha_Hospital_Logo"
      },
      {
        image: images.partner.TRINITYLOGO1,
        alt:"TRINITYLOGO1"
      },
      {
        image: images.partner.UPAS_INFORMATION_CENTER,
        alt:"UPAS_INFORMATION_CENTER"
      },
      {
        image: images.partner.vasanthi_Hospital,
        alt:"vasanthi_Hospital"
      },
      {
        image: images.partner.VIJAYA_CLINIC_DIAGNOSTICS,
        alt:"VIJAYA_CLINIC_DIAGNOSTICS"
      },
      {
        image: images.partner.VISAKA_LABORATORY,
        alt:"VISAKA_LABORATORY"
      },
    ],
  },
  HowWeWork:{
    img: images.hms.registration,
    img2: images.hms.interaction,
    img3: images.hms.reporting,
    Heading: {
      SectionTitle: "Here's How We Work",
      SubHeading:
        "A Flexible HMS & LIMS System that Suits the Special Needs of Your Hospital.",
      align: "center",
    },
    ListItems:[
      {
        heading:"1",
        subHeading:"Is the software easy to understand?",
        para:"The application is straight forward and simple to understand & very much user friendly."
      },
      {
        heading:"2",
        subHeading:"Is it accessible from anywhere?",
        para:"Our solution is accessible at any time and from any location."
      },
      {
        heading:"3",
        subHeading:"Can this product be installed on premises?",
        para:"It can run on any operating system without the need to set up any VPN connections."
      },
    ]
  },
  WhyChooseUs: {
    img:images.counter.counter4,
    Heading: {
      SectionTitle: "Our Software is Revolutionizing Business!.",
      SubHeading:
        "Thousands of healthcare providers can benefit from Vaidyo's development of affordable, adaptable, and incredibly useable technology systems to boost productivity, cut expenses, and maximize ROI.",
      align: "center",
    },
    ListItems: [
      {
        icon: images.cardSection.icon1,
        heading: "Patient Management System",
        text: "Improve efficiency at the collection sites and interact directly with your patients. Customers may be automatically notified of test results.  Test report alerts via email and What’s app are sent via Vaidyo's Automated Lab Notification module. ",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon2,
        heading: "Simplify your processes",
        text: "The Vaidyo platform is used by thousands of medical and lab professionals to streamline operations, drive growth, and maintain agility. manage numerous places with a single user interface. Supporting molecular, toxicological, as well as common clinical procedures.",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon3,
        heading: "Integrated Workflows ",
        text: "Supporting molecular, genomic, toxicological, as well as common clinical procedures",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon4,
        heading: "Integration of Instruments ",
        text: "Any instrument, such a chemical analyzer, LC-MS system, or PCR apparatus, can be connected to the Vaidyo platform. ",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon5,
        heading: "Support across facilities ",
        text: "Observe and manage numerous places with a single user interface. ",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon6,
        heading: "Revenue Cycle Control",
        text: "Get analytics and in-depth data about the factors that affect your lab's revenue and cost.",
        authorImage: images.testimonial.review2,
      },
      {
        icon: images.cardSection.icon7,
        heading: "EHR/Billing Interface ",
        text: "Will not allow EHR integrations stifle your lab's expansion. Test findings follow lab orders. To ensure a seamless workflow for both you and your clients, Vaidyo connects with EHRs. We oversee the complete EHR integration procedure from beginning to end so you may concentrate on expanding your lab services.",
        authorImage: images.testimonial.review2,
      },
    ],
  },
  ProductsSection: {
    Heading: {
      SectionTitle: "Grow Better With Vaidyo",
      SubHeading:
        "Ideal for practices, labs, and hospitals of any size, including those with many providers, single practitioners, tiny labs, diagnostic centres and regional reference labs.",
      align: "center",
    },
    TabItems: [
      {
        Heading: "Hospital Management System",
        Paragraph:
          "HMS helps to manage health care costs and improve the quality of care. Users can easily track progress and make informed decisions. It provides a secure platform for data storage and analysis. ",
        buttons: [
          {
            label: "Read More",
            path: "/product/hms",
            type: "secondary",
          },
        ],
        ProductImages: [
          {
            img: images.hms.hms1,
            alt:"hms1"
          },
          {
            img: images.hms.hms2,
            alt:"hms2"
          },
          {
            img: images.hms.hms3,
            alt:"hms3"
          },
        ],
      },
      {
        Heading: " Lab Information Management System ",
        Paragraph:
          "Lab Management Software helps to automate processes, improve accuracy, and enhance communication between staff and management. With this product, laboratories can become more efficient and productive.",
        buttons: [
          {
            label: "Read More",
            path: "/product/lims",
            type: "secondary",
          },
        ],
        ProductImages: [
          {
            img: images.labs.lab1,
            alt:"labImg1"
          },
          {
            img: images.labs.lab2,
            alt:"labImg2"
          },
          {
            img: images.labs.lab3,
            alt:"labImg3"
          },
        ],
      },
    ],
  },
  CounterSection: [
    {
      id: 1,
      count: 500,
      decimals: false,
      countSymbols: "+",
      counterText: "Customers",
      isVisible: true,
      icon: images.counter.customer,
    },
    {
      id: 2,
      count: 50000,
      decimals: false,
      countSymbols: "+",
      counterText: "Admissions",
      isVisible: true,
      icon: images.counter.hospital,
    },
    {
      id: 3,
      count: 5.0,
      decimals: true,
      countSymbols: "L+",
      counterText: "Registered Patients",
      isVisible: true,
      icon: images.counter.patient,
    },
    {
      id: 4,
      count: 1.0,
      decimals: true,
      countSymbols: "L+",
      counterText: "Lab Reports",
      isVisible: true,
      icon: images.counter.lab,
    },
    {
      id: 5,
      count: 2.0,
      decimals: false,
      countSymbols: "Million",
      counterText: "Bills Generated",
      isVisible: true,
      icon: images.counter.bill,
    },

  ],
  FAQSection: {
    Heading: {
      SectionTitle: "Any Questions? Find here.",
      SubHeading: "Gain a competitive edge while saving time.",
      align: "center",
    },
    Questions: [
      {
        Question: "Why should you rely on Vaidyo’s LIMS? ",
        Answer:
          "It is crucial to have an automated laboratory workflow in order to do your analytical work efficiently and swiftly while maintaining a high level of quality. Your laboratory processes can be automated with the help of Vaidyo’s LIMS. Unlike other LIMS, our LIMS entirely adjusts to your unique demands and specifications because processes vary from laboratory to laboratory. ",
      },
      {
        Question: "What advantages do Vaidyo’s LIMS offer me? ",
        Answer:
          "Using our LIMS software solution will greatly simplify your workflow.It fully eliminates paperwork while streamlining analytical administration and sample management. The LIMS streamlines your lab procedures, increasing your productivity and helping you save time and money. ",
      },
      {
        Question:
          "When should you think about implementing the Vaidyo’s LIMS? ",
        Answer:
          "When a LIMS system should be implemented always depends heavily on the unique requirements of each laboratory organisation. When a laboratory to conduct tests on test objects, LIMS is always helpful. This is especially crucial if a lab is applying for accreditation because it is then crucial to be able to demonstrate that data collection is trustworthy and traceable at all times.  ",
      },
      {
        Question: "How much does the LIMS Software costs? ",
        Answer:
          "We are quite delighted to provide our robust LIMS system at a pricing that is very competitive. By the way, unless you choose to sign a service contract, all of our pricing are set. With just one investment, benefit from a strong long-term LIMS.",
      },
      {
        Question: "Can LIMS software also be operated abroad?  ",
        Answer:
          "Indeed,LIMS's user interface is by default available in English as well. You can freely integrate any other language at any time using the software's high level of flexibility. ",
      },
      {
        Question: "Does Vaidyo HMS provides training?  ",
        Answer:
          "Yes, Vaidyo HMS provides training to all users as per the defined user role such as: doctors, nurses, executives, lab technicians, billing and finance, HR, etc. Apart from practical in-person training, it also offers help manuals and video tutorials for better understanding and improved efficiency. ",
      },
      {
        Question: "Is there any specific knowledge required for using Vaidyo HMS?",
        Answer:
          "No, there is NO such requirement for using Vaidyo HMS. As the application is developed in a user-friendly structure, even a novice user can easily operate the system.",
      },
      {
        Question: " Will it not be wise enough to choose a monthly subscription plan over a one-time hefty payment? ",
        Answer:
          "Yes, you are right! We want managing your account / subscription to be quick and simple so you can go back to enjoying our product by setting up automatic recurring monthly payments that are simple and easy.",
      },
      {
        Question: "What kind of hardware installations are required ?",
        Answer:
          "For a cloud-based services, Prior to the installation of vaidyo HMS, you need to make sure that the computers, networking, and internet connection are available and operational. The highly experienced Vaidyo team at is available to help you in analyzing your current setup and suggesting new equipment’s installation in a cost effective manner.",
      },
    
    ],
  },
  AboutSection: {
    Heading: {
      SectionTitle: "About Us",
      SubHeading: "",
      align: "left",
    },
    paragraph:
    " As a Vaidyo customer, you will gain a partner with extensive industry knowledge and best practices, a comprehensive platform to future-proof and expand your business, and helpful customer support. As a Vaidyo customer, you will gain a partner with extensive industry knowledge and best practices, a comprehensive platform to future-proof and expand your business, and helpful customer support.",
    buttons: [
      {
        label: "Read More",
        path: "/about",
        type: "secondary",
      },
    ],
    aboutImg:{
      img:images.about.aboutImg,
      alt:'img'
    }
  },
  channelPartnerSection: {
    Heading: {
      SectionTitle: "Requirement of New Channel Partners",
      SubHeading: "",
      align: "left",
    },
    paragraph:
    " We warmly invite distributors, value-added resellers, and resellers to join our rapidly expanding network. The flexible business models that Vaidyo offers can be favorable to the channel partners.",
    buttons: [
      {
        label: "Reach Us",
        path: "/contact",
        type: "secondary",
      },
    ],
    aboutImg:{
      img:images.channelPartner.partner_img,
      alt:'img'
    }
  },
  costSection: {
    Heading: {
      SectionTitle: "The price will be as low as Rs.500",
      SubHeading: "",
      align: "left",
    },
    paragraph:
    "LIS is offered on monthly subscription prices that starts as low as 500/- per month.",
    buttons: [
      {
        label: "Reach Us",
        path: "/contact",
        type: "secondary",
      },
    ],
    aboutImg:{
      img:images.channelPartner.partner_img,
      alt:'img'
    }
  },
  TestimonialSection: {
    img: images.testimonial.user_icon,
    Heading: {
      SectionTitle: "Testimonials",
      SubHeading:
        "It is crucial for us to collaborate with a supplier who shares the same values as our Medical Lab when it comes to service delivery, including quality, integrity, and the capacity to cater to the specific requirements of our customers.",
      align: "center",
    },
    Testimonial: [
      {
        img:"",
        name: "Dr. S Chandra Shekar",
        qualification: " Life Hospital, Srikakulam",
        review:
          "We were uncertain about which approach to adopt and how to proceed with our digitization journey when we first opened the new facility. In addition to offering us a top-notch cloud-based digital health care platform, Vaidyo Platform also offered us advice along the way, which made the process of our digital transformation easy. Their Symphony cloud-based system, which employs microservices, can quickly meet the majority of our Hospital’s needed workflows. ",
      },
      {
        img: images.testimonial.kosuru_Hospital,
        name: "Dr. Kosuru Srinivas",
        qualification: "Kosuru kidney care Hospital",
        review:
          "Vaidyo platform came to the rescue when we were searching for a cost-effective solution for our new diagnostic facility. This cloud-based platform, which is simple to scale, assisted us in continuing to grow our company. ",
      },
      {
        img: images.partner.Sri_care_Hospital,
        name: "Dr Gaddam Srikanth Reddy",
        qualification: "Sri Care hospital Narasaraopet ",
        review:
          "The Vaidyo application manages every aspect of our OPD. Management of appointments and queues is quite effective, and it has simplified and streamlined administration.  ",
      },
      {
        img: "",
        name: "Dr Abbas Urology",
        qualification: "Kidney care hospital Narasaraopet",
        review:
          "Working with the Vaidyo team to provide innovative technology-enabled solutions in the clinical setting has been incredibly successful. Their strong product-driven approach served as the foundation, and the results are evident. They are just unparalleled in the lab business for their skill in software deployment.  ",
      },
      {
        img: "",
        name: "Dr Raja Nandha Reddy",
        qualification: "Life line hospital Narasaraopet",
        review:
          "It is crucial for us to collaborate with a supplier who shares the same values as our Medical Lab when it comes to service delivery, including quality, integrity, and the capacity to cater to the specific requirements of our customers. Most importantly, the vendor needs to be equipped with the knowledge and tools necessary to guarantee that every patient gets the best care possible.",
      },
      // {
      //   img: "",
      //   name: " Nagaraju (Admin) ",
      //   qualification: "Samatha hospital Guntur ",
      //   review:
      //     "Vaidyo platform came to the rescue when we were searching for a cost-effective solution for our new diagnostic facility. This cloud-based platform, which is simple to scale, assisted us in continuing to grow our company. ",
      // },
      
    ],
  },
  FooterSection: {
    logo: {
      dark_logo: images.logos.dark_logo,
      light_logo: images.logos.light_logo,
    },
    paragraph:
      " As a Vaidyo customer, you will gain a partner with extensive industry knowledge and best practices, a comprehensive platform to future-proof and expand your business, and helpful customer support.",
    copyright: "copyright @ Finsolconsultancy.com,2023",
    quickLinks: [
      {
        id: "Home",
        links: [
          {
            label: "Home",
            path: "/",
            offset: "70",
          },
          {
            label: "About Us",
            path: "/about",
            offset: "70",
          },
        ],
      },
      {
        id: "Products",
        links: [
          {
            label: "Hospital Management System (HMS)",
            path: "/product/hms",
            offset: "70",
          },
          {
            label: "Lab Information Management System(LIMS)",
            path: "/product/lims",
            offset: "70",
          },
        ],
      },
      {
        id: "Support",
        links: [
          {
            label: "Contact Us",
            path: "contact",
            offset: "70",
          },
          {
            label: "Terms and Conditions",
            path: "terms&conditions",
            offset: "70",
          },
          {
            label: "Privacy Policies",
            path: "privacy-policy",
            offset: "70",
          },
          {
            label: "Refund Policy",
            path: "refund-policy",
            offset: "70",
          },
          {
            label: "Disclaimer",
            path: "disclaimer",
            offset: "70",
          },
        ],
      },
    ],
    socialIcons: [
      {
        id: "Follow us on",
        links: [
          {
            icon: images.footer.soc1,
            width: "40",
            path: "https://in.linkedin.com/company/finsol-consultancy-pvt-ltd",
          },
          // {
          //   icon: images.footer.soc2,
          //   width: "40",
          //   path: "/",
          // },
          // {
          //   icon: images.footer.soc3,
          //   width: "40",
          //   path: "/",
          // },
          // {
          //   icon: images.footer.soc4,
          //   width: "40",
          //   path: "/",
          // },
        ],
      },
      // {
      //   id: "Download",
      //   links: [
      //     {
      //       icon: images.footer.googlestore,
      //       width: "140",
      //       path: "/",
      //     },
      //     {
      //       icon: images.footer.applestore,
      //       width: "140",
      //       path: "/",
      //     },
      //   ],
      // },
    ],
  },

  aboutsection: {
    sectionHeading: "About Us",
    img: images.about.aboutImg,
    sectionPara:
      "The adoption of hospital management systems has grown throughout time in an effort to save costs and enhance patient care. It has also been demonstrated to improve the effectiveness and efficiency of the healthcare delivery process.Hospitals and healthcare facilities can manage their operations more successfully with the use of the software system Vaidyo. ",
  },
  socialMedia:{
    sectionListItems: [
      {
        image: images.footer.soc1,
      },
      {
        image: images.footer.soc2,
      },
      {
        image: images.footer.soc3,
      },
      {
        image: images.footer.soc4,
      }
    ],

  },
  whatVaidyoHas:{
    Heading: {
      SectionTitle: "What Vaidyo Has",
      SubHeading: "Gain a competitive edge while saving time",
      align: "center",
    },
      img1: images.hms.registration,
      img2: images.hms.interaction,
      img3: images.hms.reporting,

  },

  contactsection: {
    Heading: {
      SectionTitle: "Get In Touch",
      SubHeading: "",
      align: "left",
    },

    sectionListItems: [
      {
        image: images.contact.email,
        heading: "Email Us",
        paragraph: "vaidyosupport@finsolconsultancy.com",
      },
      {
        image: images.contact.call,
        heading: "Call Us",
        paragraph: "79950 08770",
        paragraph1: "97048 82273",
      },
      {
        image: images.contact.location,
        heading: "Company Address",
        paragraph: "H.O : 25-D, SDF-I, VSEZ, Duvvada, Visakhapatnam.",
      },
      {
        image: images.contact.location,
        heading: "Branch Office",
        paragraph: "B.O : LIC Colony, Guntur.",
        paragraph1: "B.O : 303 Shuvam Homes Patrapada, Bhuvaneswar 751019.",
      },
    
    ],
  },
  innerBannerSection: {
    sectionHeading: "Manage, Monitor, and control your Hospital!",
    sectionPara:
      "The adoption of hospital management systems has grown throughout time in an effort to save costs and enhance patient care. It has also been demonstrated to improve the effectiveness and efficiency of the healthcare delivery process.Hospitals and healthcare facilities can manage their operations more successfully with the use of the software system Vaidyo. ",
    innerBannerImage: images.labs.lab1,
  },
  innerAboutSection: {
    sectionHeading: "About US",
    sectionPara:
      " Application Solutions to Make Your Business Shine!We offer a wide range of services for you to choose from Our comprehensive range of services includes.",
    sectionListItems: [
      {
        text: "With the help of Vaidyo's array of laboratory automation solutions, you can increase productivity, throughput, efficiency, data integrity, and compliance in your lab.",
        icon: images.menu.right,
      },
      {
        text: "Digitally transform your pathology lab for effortless information management & a superior patient experience with our robust LIMS system ",
        icon: images.menu.right,
      },
      {
        text: "LIMS has a comprehensive solution for lab, data and process management. Quickly build workflows which map to actual laboratory processes",
        icon: images.menu.right,
      },
      {
        text: "Complete order administration, Custom Reports, Smart Notifications, Credit Settlement, thorough MIS Reports, and Analytics are all managed by Vaidyo's Comprehensive Lab Management. ",
        icon: images.menu.right,
      },
    ],
    icon: images.menu.right,
  },
  ErrorPage : {
    heading : "Looks like you've found the doorway to the great nothing",
    paragraph : 'Sorry about that! Please visit our hompage to get where you need to go.',
    buttons: [
      {
        label: "Home",
        path: "/",
        type: "primary",
      },
    ],
    file : images.ErrorPage.error,
  },
  innerCards: {
    sectionHeading: "Benefits for your business",
    sectionPara:
      "It is crucial for us to collaborate with a supplier who shares the same values as our Medical Lab when it comes to service delivery, including quality, integrity, and the capacity to cater to the specific requirements of our customers.",
    sectionListItems: [
      {
        img: images.testimonial.review1,
        name: "Registration and Billing",
        data: "Increased margins, lab efficiency, quicker turnaround times, and a decrease in errors will help you grow and scale your business. Data integrity through the management, tracking, and identification of patient samples. ",
      },
      {
        img: images.testimonial.review2,
        name: "Patient Interaction",
        data: "Stop having uncomfortable interactions with consumers about specimens that are mislabeled or misplaced.Real-time Queues and Customizable Reporting Templates, What’s app reporting.User-friendly UI that is intuitive and simple to use.",
      },
      {
        img: images.testimonial.review1,
        name: "Effective Reporting",

        data: "Inbuilt system reporting with dashboards that is sophisticated and customizable A thorough audit trail that documents every activity and event performed by the user and by the system.",
      },
    ],
  },
};
export default home;
